<template>
    <div class="header-contentys pt-3 d-flex align-items-center">
        <div class="mr-5">
            <h4 class="text-primary font-weight-bold">Affectations ({{ lines }})</h4>
        </div>
        <div class="mr-4">
            <NavRh></NavRh>
        </div>
        <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
            <a href="" class="btn " @click.prevent="changeAffichage('list')" :class="{ 'active': affichage === 'list' }">
                <i class="fa-solid fa-bars"></i>
            </a>
            <a href="" class="btn " @click.prevent="changeAffichage('cards')" :class="{ 'active': affichage === 'cards' }">
                <i class="fa-solid fa-border-all"></i>
            </a>
        </div>
        <div class="px-1 d-flex">
            <button class="btn btn-outline-dark" @click="openCreateModal()">
                <i class="fas fa-plus"></i> Nouvelle affectation
            </button>
        </div>
    </div>
    <hr>
    <div class="body-contentys">
        <DataTableBackend :key="key" url="/api/camion_employe" :columns="columns" :affichage="affichage" :table="table" :idParams="this.$route.params.id" selection inCard
        v-on:set-total-records="updateLines">
            <template #action_group_btns=slotProps>
                <button type="button" class="btn btn-sm btn-danger mr-2" @click="deleteGroup(slotProps.data)">
                    <i class="fas fa-trash-alt"></i> Supprimer
                </button>
            </template>
            <template #action_btns=slotProps>
                <button class="btn btn-sm btn-outline-dark" @click="openShowModal(slotProps.data)">
                    <i class="fa-solid fa-eye"></i>
                </button>
            </template>
        </DataTableBackend>
    </div>
</template>
<script >
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
import NavRh from '../NavRh.vue';
const CreateAffectation = defineAsyncComponent(() => import('./CreateAffectation.vue'));
const ShowAffectation = defineAsyncComponent(() => import('./ShowAffectation.vue'));

export default defineComponent({
    components: { NavRh },
    data() {
        return {
            lines: 0,
            key: 1,
            affichage: "list",
            isLoading: true,
            table: 'camion_employe',
            columns: [
                {
                    key: 'employe.pseudo',
                    label: 'Employe',
                    exportable: true
                },
                {
                    key: 'camion.plaque',
                    label: 'Camion',
                    exportable: true
                },
                {
                    key: 'poste',
                    label: 'Poste',
                    exportable: true
                },
                {
                    key: 'date_debut',
                    label: 'Debut',
                    format: 'date',
                    exportable: true
                },
                {
                    key: 'date_fin',
                    label: 'Fin',
                    format: 'date',
                    exportable: true
                },
                {
                    key: 'duree',
                    label: 'Duree',
                    exportable: true
                }
            ]
        }
    },
    methods: {
        changeAffichage(type) {
            this.affichage = type;
             this.key++
        },
        openCreateModal() {
            this.$dialog.open(CreateAffectation, {
                props: {
                    header: 'Nouvelle affectation',
                    style: {
                        width: '30vw'
                    },
                    modal: true
                },
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowAffectation, {
                props: {
                    header: "Affectation ID" + objData.id,
                    style: {
                        width: "30vw"
                    },
                    modal: true
                },
                data: objData
            });
        },
        deleteGroup(selection) {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }

            this.isLoading = true
            let selectedLines = []
            for (let index = 0; index < selection.length; index++) {
                const element = selection[index];
                selectedLines.push(element.id)
            }

            this.axios.post('/api/camion_employe/destroy-group', { selected_lines: selectedLines }).then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    for (let index = 0; index < response.data.message.length; index++) {
                        const element = response.data.message[index];
                        this.$toast.add({
                            severity: element.severity,
                            detail: element.value,
                            life: parseInt(5000 * (index + 1))
                        });
                    }
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        }
    }
})
</script>
    